import type { HttpClient } from '@/lib/http/client.js'
import type { Overview, OverviewQuery } from '@/types/overview/overview.type.js'

/** `admin/overview`, verified against `overview-admin.controller.ts`. One round trip. */
export interface OverviewService {
  get: (query: OverviewQuery) => Promise<Overview>
}

export function createOverviewService(http: HttpClient): OverviewService {
  return { get: (query) => http.get<Overview>('admin/overview', { query: { ...query } }) }
}
